import React from 'react';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import Activities from 'app-ui-componentlibrary/dist/go/components/common/activity/Activities';

export const mapStateToProps = (state) => {
  return {
    dynamicComponent: state.dynamicComponent,
    data: state.dynamicComponent.data,
    context: state.dynamicComponent.context,
    jwt: state.auth.token,
  };
};

export default connect(mapStateToProps)(connectDynamic(Activities));
